services.service('PnlMarginService', [
    '$rootScope',
    'constants', 'UserService', 'OpenTradeService', 'CurrencyConvertService', 'AssetService', 'Utils', 'CustomerEventsService',
    function ($rootScope, constants, UserService, OpenTradeService, CurrencyConvertService, AssetService, Utils, CustomerEventsService) {

        var self = this,
            listener,
            tradesSubscribers = [];

        self.convAssets = [];
        self.data = {
            freeMargin: 0,
            totalProfit: 0,
            netPl: 0,
            equity: 0,
            pnl: 0
        };

        setInterval(createUtilizationEvent, 10000);

        this.init = function () {
            log('PnlMarginService init');

            var user = UserService.get();
            if (!user.activeTradingAccount) {
                log('not starting PnlMarginService');
                return;
            }

            self.convAssets = CurrencyConvertService.find(AssetService, user.currency, 'USD', '', 1);


            listener = $rootScope.$on('pnl', function (e) {
                e.stopPropagation();
                e.preventDefault();
                self.profitUnSubscribe();
                self.profitSubscribe();
                self.calcTotalNetPl();
                // utilization();
            });
            self.profitUnSubscribe();
            self.profitSubscribe();
            self.calcTotalNetPl();

            // first run
            createUtilizationEvent();
        };

        this.equity = function () {
            var user = UserService.get();
            if (!user) return;

            var equity;
            equity = user.activeTradingAccount.balance + self.data.netPl + user.activeTradingAccount.credit;
            self.data.freeMargin = equity - user.activeTradingAccount.margin;

            // Old "Available funds" value for reference
            // if (equity - user.activeTradingAccount.margin >= 0) {
            //     self.data.freeMargin = equity - user.activeTradingAccount.margin;
            // } else {
            //     self.data.freeMargin = 0;
            // }

            return equity;
        };

        this.marginLevel = function () {
            var user = UserService.get();
            if (!user.loggedIn) return 0;
            //return user.margin > 0 ? (self.equity() / user.margin) * 100 : 0;

            return user.activeTradingAccount.marginLevel > 0
                ? (self.equity() / user.activeTradingAccount.marginLevel) * 100
                : 0;
        };

        this.calcTotalNetPl = function () {
            var user = UserService.get();
            if (!user.activeTradingAccount) return;

            var totalProfit = 0;
            var pnl = 0;
            OpenTradeService.collection.getAll().forEach(function (trade) {
                totalProfit += trade.profit() + trade.swap + trade.commission + trade.taxes;
                pnl += trade.profit();
            });

            self.data.totalProfit = totalProfit;
            self.data.netPl = this.data.totalProfit;
            self.data.equity = this.equity();
            self.data.pnl = pnl;

            return self.data;
        };

        this.profitSubscribe = function () {
            var trades = OpenTradeService.collection.getAll();

            trades.forEach(function (trade) {
                var subscriber = $rootScope.$watch(function () {
                    return trade.asset.bid;
                }, function profitWatchHandler(newVal, oldVal) {
                    if (newVal !== oldVal) self.calcTotalNetPl();
                });
                tradesSubscribers.push(subscriber);
            });
        };

        this.profitUnSubscribe = function () {
            tradesSubscribers.forEach(function (subscriber) {
                subscriber && subscriber();
            })
        };

        this.marginUtilization = function() {
            var user = UserService.get();
            if (!user || (user && !user.activeTradingAccount)) return 0;

            var margin = user.activeTradingAccount.margin;
            var equity = self.data.equity;

            var marginUtilization = 0;

            if (equity !== 0) {
                marginUtilization = (margin / equity) * 100;
            } else {
                if (margin !== 0) {
                    return 999;
                }
            }

            if (marginUtilization >= 0 && marginUtilization <= 200) {
                return marginUtilization;
            } else {
                return 999;
            }
        }

        this.clear = function () {
            log('Clear PnlMarginService');
            listener && listener();
            self.profitUnSubscribe();
            tradesSubscribers = [];
            self.data.freeMargin = 0;
            self.data.totalProfit = 0;
            self.data.netPl = 0;
            self.data.equity = 0;
            self.data.pnl = 0;
        };

        function createUtilizationEvent() {
            var user = UserService.get();
            if (!user || (user && !user.activeTradingAccount)) return;

            CustomerEventsService.trackEvent(CustomerEventsService.events.MarginUtilization, {
                balance: user.activeTradingAccount.balance,
                equity: self.equity(),
                credit: user.activeTradingAccount.balance,
                freeMargin: self.data.freeMargin,
                totalPnl: self.data.totalProfit,
                marginUtilization: self.marginUtilization(),
                server: user.activeTradingAccount.live ? 'live' : 'demo',
                tradingAccount: user.activeTradingAccount.login
            });
        }

        return this;
    }]);
